<div *ngIf="loading$ | async" class="loading-overlay">
    <mat-spinner></mat-spinner>
</div>
  